var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSpeedTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 24.7594C10 19.3694 14.3694 15 19.7594 15C22.2631 15 24.5466 15.9428 26.2742 17.4927L26.6941 17.149C26.9186 16.9498 27.6142 16.5264 28.2039 17.1191C28.7287 17.6466 28.3691 18.1596 28.2039 18.3255L27.746 18.9252C27.7173 18.9627 27.6919 19.0017 27.6695 19.0419C28.833 20.6487 29.5188 22.624 29.5188 24.7594C29.5188 25.5878 30.1904 26.2594 31.0188 26.2594C31.8472 26.2594 32.5188 25.5878 32.5188 24.7594C32.5188 17.7126 26.8062 12 19.7594 12C12.7126 12 7 17.7126 7 24.7594C7 25.5878 7.67157 26.2594 8.5 26.2594C9.32843 26.2594 10 25.5878 10 24.7594Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8705 18.1445C27.8748 18.1405 27.879 18.1364 27.8832 18.1322C28.0965 17.9189 28.0965 17.573 27.8832 17.3597C27.6699 17.1464 27.324 17.1464 27.1107 17.3597C27.1091 17.3613 27.1074 17.363 27.1058 17.3646L17.3294 25.5357L17.331 25.5374C17.3124 25.5544 17.294 25.572 17.276 25.59C16.6196 26.2464 16.6196 27.3106 17.276 27.9669C17.9323 28.6233 18.9965 28.6233 19.6529 27.9669C19.7117 27.9082 19.7652 27.8461 19.8135 27.7814L27.8705 18.1445Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpeedTest);
export default __webpack_public_path__ + "static/media/ic_speed_test.67c4539a8b139a5062013a28392b356e.svg";
export { ForwardRef as ReactComponent };